import "./dashboard-sections.css";
import CaseEntered   from "../../../images/db-case-entered.svg";
import CaseAccepted  from "../../../images/db-case-accepted.svg";
import CaseStored    from "../../../images/db-case-stored.svg";
import CaseProcessed from "../../../images/db-case-processed.svg";

const DUMMY = {
  cases_entered:   1300,
  cases_accepted:  1285,
  cases_sorted:    1270,
  cases_processed: 1248,
};

const STEPS = [
  { key: "cases_entered",   label: "Cases Entered",   img: CaseEntered   },
  { key: "cases_accepted",  label: "Cases Accepted",  img: CaseAccepted  },
  { key: "cases_sorted",    label: "Cases Sorted",    img: CaseStored    },
  { key: "cases_processed", label: "Cases Processed", img: CaseProcessed },
];

const ProcessFlow = ({ data = DUMMY, isLoading = false }) => (
  <div className="cmn_card pf-card">
    <div className="pf-header">
      <span className="pf-title">Inbound Process Flow</span>
      <span className="pf-live-badge">LIVE TRACKING</span>
    </div>
    <div className="pf-steps">
      {STEPS.map((step, i) => (
        <div key={step.key} className="pf-step">
          {i > 0 && <div className="pf-connector" />}
          <div className="pf-icon-wrap">
            <img src={step.img} alt={step.label} className="pf-icon-img" />
          </div>
          <div className="pf-step-label">{step.label}</div>
          <div className="pf-step-value">
            {isLoading
              ? <span className="db-shimmer" style={{ height: 28, width: 80, display: "block" }} />
              : data[step.key]?.toLocaleString()
            }
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ProcessFlow;
